import { render } from "./appraisal-add-model.vue?vue&type=template&id=5628ae9e"
import script from "./appraisal-add-model.vue?vue&type=script&lang=js"
export * from "./appraisal-add-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__